import createSurveyForm from 'utils/createSurveyForm';

export const FORM = 'surveyAddForm';

const SurveyAddForm = createSurveyForm(FORM);

export default SurveyAddForm;
